const timeZonesWorld = Intl.supportedValuesOf('timeZone');

/**
 * Returns offset in format ±HH:MM for a given timezone
 */
const getTimezoneOffset = (timeZone) => {
  const now = new Date();

  const utcDate = new Date(
    now.toLocaleString('en-US', { timeZone: 'UTC' })
  );

  const tzDate = new Date(
    now.toLocaleString('en-US', { timeZone })
  );

  const diffMinutes = (tzDate - utcDate) / (1000 * 60);

  const sign = diffMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(diffMinutes);

  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
  const minutes = String(absMinutes % 60).padStart(2, '0');

  return `${timeZone} ${sign}${hours}:${minutes}`;
};

export const timezones = timeZonesWorld.map(tz => ({
  label: tz,
  value: getTimezoneOffset(tz)
}));
